import { gql } from '@apollo/client';

export const ALL_INSTITUTION_TYPES = gql`
  query AllInstitutionTypes($input: InstitutionTypesInput) {
    institutionTypes: getInstitutionTypes(input: $input) {
      id
      name
    }
  }
`;
